import React from 'react';
import classNames from 'classnames';
import Money from 'common/components/money';

/**
 * Project cost breakdown based on package features and user choices.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const CostBreakDown = ({detailedCost: {total, items}, packageName, showGrandTotal = true}) => {
  const packageClass = packageName? "package-" + packageName.toLowerCase():""
  const showTotal = showGrandTotal

  return (
      <div className={classNames('pap-price-summary', packageClass)}>
        {packageName && <h3>{packageName} Package</h3>}
        <table className="pap-price-summary-table">
          <tbody>
            {items.map((item, i) => {
              const price = parseFloat(item.price)
              return (
                <tr key={i}>
                  <td className="pap-price-item">{item.name}</td>
                  <td className={classNames("pap-price-value", {"text-success": price < 0})}>
                    {price == 0? 'FREE' : <Money value={price}/>}
                  </td>
                </tr>
            )})}
          </tbody>

          {showTotal &&
          <tfoot className="pap-price-grand-total">
            <tr>
              <td className="pap-price-item">Total Cost</td>
              <td className="pap-price-value">{total > 0? <Money value={total}/>:'$0.00'}</td>
            </tr>
          </tfoot>
          }
        </table>
      </div>
  )
};

export default CostBreakDown;



// WEBPACK FOOTER //
// ./pap/components/common/cost_breakdown.jsx